import React from 'react';
import { Box } from '@mui/material';

import { getCandidateVideoInterviewUrl } from '@constants';
import { ICandidateDetails } from '@types';
import {
  CandidateCardSection,
  ClosedBanner,
  getCandidateSections,
  getCandidateVideo,
  ICandidateSection,
} from '../CandidateDetailSections/CandidateDetailSections';
import { VideoIntro } from '../CandidateVideoIntro/CandidateVideoIntro';

interface ICandidateDetailsContent {
  data: ICandidateDetails;
  isViewOnly?: boolean;
}

export const DetailsContent: React.FC<{
  videoUrlAPI: string | null;
  sections: ICandidateSection[];
  children?: React.ReactNode;
}> = ({ videoUrlAPI, sections, children }) => (
  <Box display="flex" flexDirection="column" gap={2}>
    {children}

    {Boolean(videoUrlAPI) && <VideoIntro videoUrlAPI={videoUrlAPI!} />}

    {sections.map((section) => (
      <CandidateCardSection key={section.title} title={section.title}>
        {section.content}
      </CandidateCardSection>
    ))}
  </Box>
);

export const CandidateDetailsContent: React.FC<ICandidateDetailsContent> = ({
  data,
  isViewOnly = false,
}) => {
  const video = getCandidateVideo(data);

  return (
    <DetailsContent
      videoUrlAPI={
        video && getCandidateVideoInterviewUrl(video.recordFileName!)
      }
      sections={getCandidateSections(data, { isViewOnly, includeVideo: false })}
    >
      <Box sx={{ '&:empty': { display: 'none' } }}>
        <ClosedBanner data={data} />
      </Box>
    </DetailsContent>
  );
};
